export default __webpack_public_path__ + "7cd33fdd43bd351e899217f41215f0f7.png";